import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { Root } from './IconButton.styles';
var IconButton = forwardRef(function (props, ref) {
  var _a = props.size,
      size = _a === void 0 ? 'compact' : _a,
      _b = props.color,
      color = _b === void 0 ? 'secondary' : _b,
      buttonProps = __rest(props, ["size", "color"]);

  var children = buttonProps.children,
      otherProps = __rest(buttonProps, ["children"]);

  return _jsx(Root, __assign({
    type: "button"
  }, otherProps, {
    ref: ref,
    size: size,
    color: color
  }, {
    children: children
  }));
});
export default memo(IconButton);